// extracted by mini-css-extract-plugin
export var img = "Logo-module--img--zcpXQ";
export var root = "Logo-module--root--hGIaJ";